// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 471 ? "67e56481" : chunkId) + "." + {"471":"b868ff88b9f409d0","716":"1a84d28222fbdcd7"}[chunkId] + ".js";
};